import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M9 0c-.712 0-1.287.559-1.287 1.25V2c-2.933.578-5.142 3.102-5.142 6.125v.734a7.4 7.4 0 0 1-1.949 4.985l-.297.324a1.228 1.228 0 0 0-.213 1.344c.205.449.667.738 1.173.738h15.428c.506 0 .965-.29 1.174-.738a1.22 1.22 0 0 0-.213-1.344l-.298-.324a7.393 7.393 0 0 1-1.948-4.985v-.734c0-3.023-2.21-5.547-5.143-6.125v-.75C10.285.559 9.71 0 8.999 0Zm1.82 19.27a2.466 2.466 0 0 0 .75-1.77H6.428c0 .664.269 1.3.751 1.77A2.61 2.61 0 0 0 9 20a2.61 2.61 0 0 0 1.82-.73Z"
    }, null, -1)
  ]))]))
}
export default { render: render }